import { default as AnalysisResults, doubleEncodeInputs } from './AnalysisResults'
import { get } from 'tools/request'
//import { metaAnalysisInputs } from 'model/MetaAnalysis'
import { questionAsParameters, analysisType } from 'model/SearchQuery'
/*import * as defaultTemplate from './templates/meta.rmd'
import * as defaultR from './templates/meta.r'*/
import { lastMedian } from 'model/Analysis'

class MetaAnalysisReport extends AnalysisResults {
	get fileName() {
		return (analysisType == 'bayesian' || analysisType == 'cohort') ? 'report' : 'demoReport'
	}
	get analysisType() {
		return analysisType
	}
	get defaultTemplate() {
		return defaultTemplate
	}
	get defaultR() {
		return defaultR
	}
	async sendAnalysisRequest(isTemplated?: boolean) {
		return get('/portal/analysis/metaReport?' + (await questionAsParameters()) +
			(this.config.regression ? '&regression=' + encodeURIComponent(this.config.regression) : '')
			/* +
			'&medianTreatment=' + encodeURIComponent(lastMedian?.name) +
			'&medianValue=' + lastMedian?.value*/).finally(() => {
			document.getElementsByClassName('loader')[0].remove()
			document.querySelector('.meta-analysis').classList.remove('disabled-link')
		})
	}
}

export default MetaAnalysisReport
